<template>
  <button
    :class="[
      'own-button',
      `own-button--variant-${variant}`,
      resolvedSize !== 'regular' && `own-button--${resolvedSize}`,
      {
        'own-button--active': active,
        'own-button--icon-only': !text,
        'own-button--processing': processing,
        'own-button--disabled': disabled,
      },
    ]"
    :disabled="disabled"
    :type="type"
    v-bind="$attrs"
    @click.stop="onClick"
  >
    <span v-if="processing" class="own-button__spinner">
      <svg
        class="own-button__spinner-svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12"
          cy="12"
          r="10.75"
          stroke-width="2.5"
          stroke="currentColor"
          opacity="0.15"
        />
        <circle
          class="own-button__spinner-arc"
          cx="12"
          cy="12"
          r="10.75"
          stroke-width="2.5"
          stroke="currentColor"
          stroke-linecap="round"
          :stroke-dasharray="67.5"
        />
      </svg>
    </span>

    <span
      v-if="$slots['icon-left']"
      :class="['own-button__icon', processing && 'own-button__hidden']"
    >
      <slot name="icon-left" />
    </span>

    <span
      v-if="text"
      :class="[
        'text-button-regular',
        {
          'text--truncate': textTruncate,
          'own-button__text--icon-left': $slots['icon-left'],
          'own-button__text--icon-right': $slots['icon-right'],
        },
        processing && 'own-button__hidden',
      ]"
      v-text="text"
    ></span>

    <span
      v-if="$slots['icon-right']"
      :class="['own-button__icon', processing && 'own-button__hidden']"
    >
      <slot name="icon-right" />
    </span>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    active?: boolean
    disabled?: boolean
    processing?: boolean
    size?: 'small' | 'regular' | 'large'
    small?: boolean
    text?: string
    textTruncate?: boolean
    type?: 'button' | 'submit' | 'reset'
    variant?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger'
  }>(),
  {
    active: false,
    disabled: false,
    processing: false,
    size: undefined,
    small: false,
    text: undefined,
    textTruncate: false,
    type: 'button',
    variant: 'secondary',
  }
)

const resolvedSize = computed(() => {
  if (props.size) return props.size
  if (props.small) return 'small'
  return 'regular'
})

const emit = defineEmits<{
  click: [data: MouseEvent]
}>()

const onClick = (event: MouseEvent) => {
  if (!props.processing) {
    emit('click', event)
  }
}
</script>

<style lang="scss" scoped src="./_own-button.scss" />
